import React from "react"

const ProductsContext = React.createContext()

export default ProductsContext
